import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ReactModal from "react-modal";
import {
  useCreateServiceMasterMutation,
  useDeleteServiceMasterMutation,
  useGetServiceMasterDetailsQuery,
} from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import AddServiceMaster from "./AddServiceMaster";
import { formatDate } from "../../../components/reusableComponent/DateFormat";
import EditServiceMaster from "./EditServiceMaster";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { GARAGE_ID, WORKSHOP_ID } from "../../../constants";
import DeleteServiceMaster from "./DeleteServiceMaster";

const ServiceMaster = () => {
  const [serviceMasterData, setServiceMasterData] = useState<any>([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [serviceMasterDetails, setServiceMasterDetails] = useState({});
  const [openEditServiceMasterModal, setOpenEditServiceMasterModal] =
    useState(false);
  const [openDeleteServiceMasterModal, setOpenDeleteServiceMasterModal] =
    useState(false);
const [totalItems, setTotalCount] = useState(0);

const ITEMS_PER_PAGE = 20;


const [currentPage, setCurrentPage] = useState<any>(1);
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);


  const getWorkshopId = localStorage.getItem(WORKSHOP_ID);

  const [createServiceMasterTrigger] = useCreateServiceMasterMutation();
  const {
    data: serviceMaster,
    status,
    isLoading,
    refetch,
  } = useGetServiceMasterDetailsQuery({
    id: getWorkshopId,
    currentpage: currentPage
  });
  const [triggerDeleteService] = useDeleteServiceMasterMutation();

  useEffect(() => {
    if (status === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [status]);

  useEffect(() => {
    if (serviceMaster) {
      setServiceMasterData(serviceMaster?.results);
      setTotalCount(serviceMaster?.count || 0);
    }
  }, [serviceMaster]);

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const closeModal = () => {
    setModalOpen(false);
    setOpenEditServiceMasterModal(false);
    setOpenDeleteServiceMasterModal(false);

    // setEditConsentMaster(false)
    // setIsActiveModalOpen(false)
    // setIsInactiveModalOpen(false)
  };

  const customModalStyles1: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "70%",
      border: "none",
      boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
      borderRadius: "40px",
      padding: "5px",
    },
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
    paddingBottom: "0",
  };

  const isEditModal = (workshop) => {
    setServiceMasterDetails(workshop);
    setOpenEditServiceMasterModal(true);
  };

  const deleteService = (service) => {
    setServiceMasterDetails(service);
    setOpenDeleteServiceMasterModal(true);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };
  return (
    <div className="vehicle-info-cont">
      {/* <div>
          </div> */}
      <div className="workshops-container">
        <div className="workshops-header">
          <p
            style={{
              margin: "0",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontWeight: "200",
                fontSize: "20px",
                fontFamily: "karbon",
                color: "#666666",
              }}
            >
              Service Master
            </span>
            <span
              onClick={() => setModalOpen(true)}
              style={{
                color: `${selectedButtonColors}`,
                background: `${selectedButtonBackgoundColors}`,
                border: "none",
                padding: "10px 15px",
                borderRadius: "20px",
                cursor: "pointer",
              }}
            >
              + Add Service
            </span>
          </p>
        </div>
        {isLoading || tableLoader ? (
          <LoadingSpinner />
        ) : (
          <div className="workshops-table-container">
            <table className="workshops-table">
              <thead style={{ fontSize: "16px" }}>
                <tr style={{ background: "#F7D3C5" }}>
                  <th className="table-header">Sr.No</th>
                  <th className="table-header">Brand</th>
                  <th className="table-header">Model</th>
                  <th className="table-header">Fuel Type</th>
                  <th className="table-header">Service type</th>
                  <th className="table-header">Sub Service type</th>
                  <th className="table-header">
                    <>
                      <i
                        className="bi bi-currency-rupee"
                        style={{ color: "black" }}
                      ></i>
                      Labour Cost
                    </>
                  </th>
                  <th className="table-header">
                    <>
                      <i
                        className="bi bi-currency-rupee"
                        style={{ color: "black" }}
                      ></i>
                      Price
                    </>
                  </th>

                  <th className="table-header">Description</th>
                  <th className="table-header">Created at</th>
                  <th className="table-header">Action</th>

                  {/* <th className='table-header'>Status</th> */}
                  {/* <th className="table-header">Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {serviceMasterData?.map((workshop, index) => (
                  <tr
                    key={workshop.id}
                    className={index % 2 === 1 ? "row-alternate" : "row-normal"}
                  >
                    <td className="table-cell">{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.brand_name)}
                    </td>
                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.model_name)}
                    </td>
                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.fuel_type_name)}
                    </td>
                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.service_type_name)}
                    </td>
                    <td className="table-cell">
                      {capitalizeFirstLetter(workshop?.sub_service_type_name)}
                    </td>
                    <td className="table-cell">{workshop?.labour_cost}</td>
                    <td className="table-cell">{workshop?.price}</td>

                    <td className="table-cell">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: workshop.description,
                        }}
                      />
                    </td>

                    <td className="table-cell">
                      {formatDate(workshop?.created_at)}
                    </td>
                    <td className="table-cell">
                      <button
                        className="text-hover-primary border-0 bg-white me-2"
                        title="Edit"
                        // onClick={() =>
                        //     EditModal(
                        //       inventory.id
                        //     )
                        // }
                        onClick={() => isEditModal(workshop)}
                      >
                        <i
                          className="bi bi-pencil"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            background: index % 2 === 0 ? "white" : "#FFF1EC",
                          }}
                        ></i>
                      </button>

                      <button
                        className="text-hover-primary border-0 bg-white me-2"
                        title="Delete"
                        // onClick={() =>
                        //     EditModal(
                        //       inventory.id
                        //     )
                        // }
                        onClick={() => deleteService(workshop)}
                      >
                        <i
                          className="bi bi-trash"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            background: index % 2 === 0 ? "white" : "#FFF1EC",
                          }}
                        ></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


    <div className="pagination-footer">
        <div className="pagination-info">
          Showing {startIndex + 1} - {endIndex} of {totalItems}
        </div>

        <div className="pagination-controls">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => {
            const pageNum = i + 1;
            return (
              <button
                key={pageNum}
                onClick={() => handlePageChange(pageNum)}
                className={`pagination-btn ${pageNum === currentPage ? 'active' : ''}`}
              >
                {pageNum}
              </button>
            );
          })}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      </div>

        <ReactModal
          isOpen={modalOpen}
          onRequestClose={closeModal}
          style={customModalStyles1}
        >
          <AddServiceMaster closeModal={closeModal} refetch={refetch} />
        </ReactModal>

        <Modal
          open={openEditServiceMasterModal}
          onClose={closeModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={{ ...style, position: "absolute" }}>
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: "fixed",
                top: 16,
                right: 16,
                zIndex: 1301,
                background: "white",
              }} // Ensure it's above the modal content
            >
              <GridCloseIcon />
            </IconButton>
            <Typography
              id="modal-title"
              variant="h5"
              component="h2"
              sx={{ mb: 2 }}
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "karbon",
                color: "#666666",
                fontSize: "20px",
              }}
            >
              Edit service master
            </Typography>

            <Box>
              <EditServiceMaster
                closeModal={closeModal}
                refetch={refetch}
                storeValue={serviceMasterDetails}
                // agentMappingQueueData={agentMappingQueueData}
              />
            </Box>
          </Box>
        </Modal>

        <Modal
          open={openDeleteServiceMasterModal}
          onClose={closeModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={{ ...style, position: "absolute" }}>
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: "fixed",
                top: 16,
                right: 16,
                zIndex: 1301,
                background: "white",
              }} // Ensure it's above the modal content
            >
              <GridCloseIcon />
            </IconButton>
            <Typography
              id="modal-title"
              variant="h5"
              component="h2"
              sx={{ mb: 2 }}
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "karbon",
              }}
            >
              Delete Service Master
            </Typography>

            <Box>
              <DeleteServiceMaster
                closeModal={closeModal}
                refetch={refetch}
                storeValue={serviceMasterDetails}
                triggerDeleteService={triggerDeleteService}
                // agentMappingQueueData={agentMappingQueueData}
              />
            </Box>
          </Box>
        </Modal>

        {/* <ReactModal
                          isOpen={editConsentMaster}
                          onRequestClose={closeModal}
                          style={customModalStyles1}
                        
                        >
                          <UpdateConsentMaster
            
                          storedWorkshopData={storedWOrkshopData}
                            closeModal={closeModal}
                            refetch={refetch}
                
                          />
                        </ReactModal> */}
      </div>
    </div>
  );
};

export default ServiceMaster;
